import { userDTO } from "../../types/types";
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { Course } from "../../types/types";

type StudentProfile = userDTO & {
  password: string;
  confirmPassword: string;
  courses: Course[];
  quizs: string[];
};

type StudentsResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: StudentProfile;
};
export const getUserProfile = async (): Promise<StudentsResponse> => {
  try {
    const response = await axios.get(`/student/profile`);

    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
